import { CommonModule } from '@angular/common';
import { Component, effect, ElementRef, EventEmitter, HostBinding, HostListener, inject, Input, Output, signal, viewChild } from '@angular/core';
import { PrimeNGConfig } from '@gridscale/primeng17/api';
import { SharedModule } from '../../../helper/shared.module';
import { ZIndexUtils } from '@gridscale/primeng17/utils';
import { A11yFocusDirective } from '../../../helper/directives/a11yfocus.directive';
import * as _ from 'lodash';

@Component({
    selector: 'ig-autocomplete-overlay',
    // templateUrl: './autocomplete-overlay.component.html',
    template: `
<div
  *ngIf="visible()"
  [attr.id]="id"
  [ngClass]="panelClass"
  [style.maxHeight]="hostStyleMaxHeight"
  igA11yFocus
  #overlayFocus="igA11yFocus"
  [igA11yFocusFirst]="false"
  [igA11yFocusLast]="false"
>
  <ng-content></ng-content>
</div>`,
    styleUrls: ['./autocomplete-overlay.component.scss'],
    imports: [
        A11yFocusDirective,
        CommonModule,
        SharedModule
    ]
})
export class AutocompleteOverlayComponent {
  @Input({ required: true }) target!: HTMLElement;
  /**
   * if multiple values can be selected
   */
  @Input() panelStyleClass?: string;

  @Output() onKeyEsc = new EventEmitter<KeyboardEvent>();
  @Output() onKeyArrowDown = new EventEmitter<KeyboardEvent>();
  @Output() onKeyArrowUp = new EventEmitter<KeyboardEvent>();


  @HostBinding('style.top') get hostStyleTop() { return this.target.getBoundingClientRect().bottom + 'px' }
  @HostBinding('style.left') get hostStyleLeft() { return this.target.getBoundingClientRect().left + 'px' }
  @HostBinding('style.minWidth') get hostStyleWidth() { return this.target.getBoundingClientRect().width + 'px' }
  @HostBinding('style.maxHeight') get hostStyleMaxHeight() { return (window.innerHeight - this.target.getBoundingClientRect().top - this.target.getBoundingClientRect().height) + 'px' }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (event.code === 'Escape') {
      this.onKeyEsc.emit(event);
    }
    if (event.code === 'ArrowDown') {
      this.onKeyArrowDown.emit(event);
    }
    if (event.code === 'ArrowUp') {
      this.onKeyArrowUp.emit(event);
    }
  }


  config = inject(PrimeNGConfig);
  el = inject(ElementRef);
  visible = signal(false);
  #visibleLast = false;
  id = _.uniqueId('igAutocompleteOverlay');

  overlayFocus = viewChild<A11yFocusDirective>('overlayFocus');

  constructor() {
    effect(() => {
      const overlayFocus = this.overlayFocus();
      const visible = this.visible();

      if (overlayFocus && this.#visibleLast !== visible) {
        this.#visibleLast = visible;
        if (visible) {
          overlayFocus.triggerShow();
        } else {
          overlayFocus.triggerHide();
        }
      }

    })
  }

  get panelClass() {
    return {
      'ig-autocomplete-panel': true,
      [this.panelStyleClass || 'xxx']: !!this.panelStyleClass
    };
  }

  show() {
    ZIndexUtils.set('ig-overlayalerref', this.el.nativeElement, this.config.zIndex.modal);

    // move DOM element to the body
    document.body.appendChild(this.el.nativeElement);

    this.visible.set(true);
  }

  hide() {
    this.visible.set(false);
  }
}
